import { useSelector } from "react-redux";
import SvgComponent from "../SvgComponent";

export const AccordionItem = ({ title, content, index, isOpen, onToggle }) => {

    const language = useSelector((state) => state.language.value);

    return (
      <div className="w-full">
    
          <button
            type="button"
            className={`flex items-center   ${language === "_ar" ? "flex-row-reverse  text-right" : "text-left"} justify-between ${
                isOpen ? 'text-black font-bold' : 'text-secondaryTextColor font-medium'
              }  w-full  rtl:text-right lg:text-F16 text-F14 focus:ring-0  `}
            aria-expanded={isOpen}
            onClick={() => onToggle(index)}
          >
            <div>{title}</div>
        {/* <SvgComponent/> */}
        <SvgComponent
        name={"ChevronDown"}
        className={`md:w-3 md:h-3 w-2.5 h-2.5 transition-transform text-secondaryTextColor transform ${isOpen ? 'rotate-180' : ''} shrink-0`}
        stroke={"#727272"}
        fill={"none"}
      />


          </button>
       
        <div
          className={ `  ${isOpen ? '' : 'hidden'} w-full `}
          aria-labelledby={`accordion-collapse-heading-${index + 1}`}
        >
          <div className={` pb-6 pt-5 lg:text-F16 text-F14 font-normal flex ${language === "_ar" ? "flex-row-reverse text-right" : "text-left"} ${isOpen ? 'text-black' : 'text-secondaryTextColor '}  dark:border-gray-700 dark:bg-gray-900`}>
            {content}
          </div>
        </div>
      </div>
    );
  };
  